/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256.533.641C397.622.641 512 115.02 512 256.107c0 141.09-114.377 255.467-255.466 255.467S1.067 397.196 1.067 256.107C1.067 115.02 115.444.641 256.533.641zm85.82 163.092l-123.29 146.111-48.428-56.485c-6.319-7.395-17.467-8.25-24.89-1.904-7.395 6.347-8.25 17.495-1.903 24.89l61.948 72.241c3.34 3.919 8.25 6.154 13.383 6.154h.056a17.782 17.782 0 0013.466-6.264L369.34 186.499c6.263-7.45 5.325-18.571-2.125-24.863-7.45-6.291-18.571-5.325-24.862 2.097z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconVerified = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconVerified.defaultProps = {
  theme,
};
IconVerified.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconVerified.displayName = 'IconVerified';
export { IconVerified };
